import { render, staticRenderFns } from "./pupilreportcardmodal.vue?vue&type=template&id=6d9535cf&"
import script from "./pupilreportcardmodal.vue?vue&type=script&lang=js&"
export * from "./pupilreportcardmodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports